<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header
        :header-title="$t('UNBLOCK_CONTACT.TITLE')"
        :header-content="$t('UNBLOCK_CONTACT.CONFIRM.MESSAGE')"
        :header-content-value="contact.name"
      />
      <div class="modal-footer">
        <woot-button variant="clear" @click="onCancel">
          {{ $t('UNBLOCK_CONTACT.FORM.CANCEL') }}
        </woot-button>
        <woot-button
          variant="smooth"
          :disabled="uiFlags.isBlocking"
          :is-loading="uiFlags.isBlocking"
          @click="onUnblock"
        >
          {{ $t('UNBLOCK_CONTACT.FORM.SUBMIT') }}
        </woot-button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    contact: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
  },
  methods: {
    async onUnblock() {
      try {
        await this.$store.dispatch('contacts/unblock', this.contact.id);
        this.showAlert(this.$t('UNBLOCK_CONTACT.FORM.SUCCESS_MESSAGE'));
        this.$emit('unblocked');
      } catch (error) {
        this.showAlert(
          error.message || this.$t('UNBLOCK_CONTACT.FORM.ERROR_MESSAGE')
        );
      }
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
